import React from 'react';

const tagColors = {
  'Glowy': 'bg-[#e5e1f9]/70 text-[#5b21b6] border-[#ddd6fe]',
  'Smooth': 'bg-[#d1ece5]/70 text-[#0f766e] border-[#bbf7d0]',
  'Even tone': 'bg-[#d1ece5]/70 text-[#0f766e] border-[#bbf7d0]',
  'Dry': 'bg-[#ffe0d2]/70 text-[#c2410c] border-[#fed7aa]',
  'Puffy': 'bg-[#ffe0d2]/70 text-[#c2410c] border-[#fed7aa]',
  'Breakout': 'bg-white/60 text-slate-600 border-white/80',
  'Acne': 'bg-white/60 text-slate-600 border-white/80',
  'Inflamed': 'bg-white/60 text-slate-600 border-white/80',
};

export default function TagPill({ tag, small = false }) {
  const colors = tagColors[tag] || 'bg-white/60 text-slate-600 border-white/80';
  
  return (
    <span className={`border rounded-full font-sans font-medium backdrop-blur-sm ${small ? 'text-xs px-2 py-0.5' : 'text-xs px-3 py-1'} ${colors}`}>
      {tag}
    </span>
  );
}